import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function SaveIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 20} height={height || 19.5} viewBox="0 0 20 19.5">
      <path
        data-name="Path 1053"
        d="M335.771 183.428v13.256a1.646 1.646 0 01-1.625 1.666H317.4a1.646 1.646 0 01-1.626-1.666v-16.168a1.646 1.646 0 011.626-1.666h12.957a1.841 1.841 0 011.15.488l3.791 2.912a1.936 1.936 0 01.473 1.178zm-1.625 13.048v-12.962a.249.249 0 00-.059-.147l-3.6-2.716v3.475a.823.823 0 01-.813.833h-7.911a.823.823 0 01-.813-.833v-3.61h-3.35a.206.206 0 00-.2.208v15.752a.206.206 0 00.2.208h16.343a.206.206 0 00.203-.208zm-4.943-6.191a3.493 3.493 0 11-3.492-3.493 3.5 3.5 0 013.489 3.493zm-6.628-9.769v2.777h6.285v-2.777zm5.036 9.769a1.9 1.9 0 10-1.9 1.9 1.9 1.9 0 001.9-1.9z"
        fill={color || "#bbb"}
        transform="translate(-315.771 -178.85)"
      />
    </svg>
  );
}
